export const TILES_STORAGE_KEY = 'photo-tiles'

export const PENDING_TILES_STORAGE_KEY = 'pending-upload-photo-tiles'
